class QueryStringUtil {

    getQueryParam(paramName: string, queryString?: string) {
        // By default, look at the current url to get a query string, unless one was provided.
        if(!queryString) {
            queryString = window.location.search;
        }

        const queryStr = unescape(queryString) + '&';
        const regex = new RegExp('.*?[&\\?]' + paramName + '=(.*?)&.*');
        const val = queryStr.replace(regex, "$1");
        return val === queryStr ? null : val;
    }
}

export const queryStringUtil = new QueryStringUtil();